import React from "react";
import { observer } from "mobx-react-lite";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import Media from "../../api/Media";
import stateFilter from "../../state/state.filter";

const PERIODS = [5, 15, 30, 60];

export const FilterByDay = observer((props) => {
  if (props.variant === "v4") {
    const activePeriod = props.selectedPeriod;
    return (
      <div className="reports-period-filters">
        <CcV4Toggle
          label={!Media.mobile ? "Только с подпиской" : "Подписка"}
          active={stateFilter.subscription_companies}
          onClick={props.onClickSubscription}
        />
        <div className="subscription-period-chips reports-period-chips">
          {PERIODS.map((days) => (
            <button
              key={days}
              type="button"
              className={`subscription-period-chip${
                activePeriod === days && !props.calendar
                  ? " subscription-period-chip--active"
                  : ""
              }`}
              onClick={props.onClick}
            >
              {days}
            </button>
          ))}
        </div>
        <label className="reports-date-field">
          <span className="site-form-label">Дата окончания</span>
          <input
            value={props.calendar}
            onChange={props.handlerPeriodCalendar}
            className="site-form-control subscription-date-input"
            type="date"
            min={props.minDay}
          />
        </label>
      </div>
    );
  }

  return (
    <div className="client_filterbar_show_period_container">
      <div className="checkbox_active_client text_soft_filter_version">
        {!Media.mobile ? "Только с подпиской" : "подписка"}
        <CcV4Toggle
          label=""
          active={stateFilter.subscription_companies}
          onClick={props.onClickSubscription}
        />
      </div>
      <span className={props.className5} onClick={props.onClick}>
        5
      </span>
      <span className={props.className15} onClick={props.onClick}>
        15
      </span>
      <span className={props.className30} onClick={props.onClick}>
        30
      </span>
      <span className={props.className60} onClick={props.onClick}>
        60
      </span>
      <label className="text_soft_filter_version">
        <span>Укажите вручную:</span>
        <input
          value={props.calendar}
          onChange={props.handlerPeriodCalendar}
          className="calendar"
          type="date"
          min={props.minDay}
        />
      </label>
      <span className="client_filterbar_show_period_span">Выберите период</span>
    </div>
  );
});
